module.exports = __webpack_public_path__ + "img/atzaga_yes.2ddb4d05.png";